var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPivot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3044_6577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3044_6577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 13.6667L2 11.0001L4.66667 8.3334L5.6 9.26673L4.56667 10.3334H10C10.3667 10.3334 10.6806 10.2028 10.9417 9.94173C11.2028 9.68062 11.3333 9.36673 11.3333 9.00007V4.26673L10.2667 5.3334L9.33333 4.40007L12 1.7334L13.3333 3.06673L14.6667 4.40007L13.7333 5.3334L12.6667 4.26673V9.00007C12.6667 9.7334 12.4056 10.3612 11.8833 10.8834C11.3611 11.4056 10.7333 11.6667 10 11.6667H4.56667L5.6 12.7334L4.66667 13.6667Z",
    fill: "#6D6E71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivot);
export default __webpack_public_path__ + "static/media/pivot.70c0af48946e5a17daf9b2fe6d064d28.svg";
export { ForwardRef as ReactComponent };